/* istanbul ignore file */
import { BaseStore } from '@lumapps/redux/types';

import { canAccessBroadcast } from './ducks/selectors';

export const mapStateToProps = (state: BaseStore) => ({
    isAllowed: canAccessBroadcast(state),
});
